import { skipToken } from '@tanstack/react-query';
import { useEffect, useRef, useState } from 'react';
import { readFileAsUint8Array } from '../../utils/readFile.ts';
import { trpc } from '../../utils/trpc/trpc.ts';


export function usePdfState(initialProtocolId: string | null) {
    const [originalPdf, setOriginalPdf] = useState<Uint8Array | null>(null);
    const [newPdf, setNewPdf] = useState<Uint8Array | null>(null);
    const pdfToUpload = useRef<Uint8Array | null>(null);

    const originalPdfFetch = trpc.protocolFiles.getPdf.useQuery(
        (initialProtocolId && !originalPdf)
            ? { protocolId: initialProtocolId }
            : skipToken,
        { refetchOnWindowFocus: false }
    );

    // Load the PDF only once
    useEffect(() => {
        if (originalPdfFetch.data && !originalPdf) {
            setOriginalPdf(originalPdfFetch.data);
        }
    }, [originalPdfFetch.data, originalPdf]);

    const handleSetPdfFile = async (file: File) => {
        const data = await readFileAsUint8Array(file);
        if (data === null || data.length === 0) {
            alert('Failed to read PDF file.');
            return;
        }

        setNewPdf(data);
        pdfToUpload.current = data;
    }

    const handlePdfDataUploaded = (data: Uint8Array) => {
        if (data === pdfToUpload.current) {
            pdfToUpload.current = null;
        }
    }


    return {
        isPdfLoading: !originalPdfFetch.data && originalPdfFetch.isLoading,
        isPdfError: !!originalPdfFetch.error,
        pdfData: newPdf ?? originalPdf ?? null,
        pdfDataToUpload: pdfToUpload.current,
        handleSetPdfFile,
        handlePdfDataUploaded,
    }
}
